import { API_ROOT } from '../constants'
import axios from 'axios'
import api from '../utils/api'

const updateSite = (formData, config) => axios.post(`${API_ROOT}/update-domain`, formData, config)

export const listFiles = (formData, config) => api.post(`${API_ROOT}/v3/editor/list`, formData, config)

export const updatePDF = (formData, config) => api.post(`${API_ROOT}/v3/editor/update-pdf`, formData, config)

export default updateSite
